import React from 'react';
import { MonitorUp } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { REMOTE_CAPTURE_DESCRIPTION, REMOTE_CAPTURE_LABEL } from '@/lib/remote-capture';

/** "Remote" label for Posture analyses / SoP assessments captured via screen share. */
export default function RemoteCaptureBadge({ className }: { className?: string }) {
  return (
    <Badge variant="outline" className={cn('gap-1 text-xs', className)} title={REMOTE_CAPTURE_DESCRIPTION}>
      <MonitorUp className="h-3 w-3" aria-hidden />
      {REMOTE_CAPTURE_LABEL}
    </Badge>
  );
}
